import { Form, Radio, Select } from 'antd';
import { useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { CustomInput } from 'app/components/fields/Input';
import {
  AutoInventoryStepsModern,
  ModifierType,
} from 'app/typings/autoInventory';
import { parseInputNumber } from 'app/utils/typing';

import type { AutoInventoryFormValues } from '../../../../types';
import { ConfigStep } from '../ConfigStep/ConfigStep';

import styles from './Bar.module.scss';

const RULES = [{ required: true, message: 'Required' }];

type BarProps = {
  handleStepChange: (step: AutoInventoryStepsModern) => void;
  onDeactivate?: () => void;
  isDisabling?: boolean;
  isNextLoading?: boolean;
};

export const Bar = ({
  handleStepChange,
  onDeactivate,
  isDisabling,
  isNextLoading,
}: BarProps) => {
  const { currencySymbol } = useContext(CurrencyContext);
  const matchOTAPrice =
    Form.useWatch<AutoInventoryFormValues['matchOTAPrice']>('matchOTAPrice');

  return (
    <ConfigStep
      step={AutoInventoryStepsModern.bar}
      className={styles.bar}
      handleStepChange={handleStepChange}
      onDeactivate={onDeactivate}
      isDisabling={isDisabling}
      isNextLoading={isNextLoading}
    >
      <p className={styles.explanation}>
        Help us calculate your BAR based on the pricing rule you applied on
        Booking.com.
      </p>

      <Form.Item name="matchOTAPrice" noStyle>
        <Radio.Group className={styles.radioGroup}>
          <Radio value={true} className={styles.radio}>
            My BAR RO (NA/NR) is equal to my OTA price
          </Radio>

          <div className={styles.withCustomForm}>
            <Radio value={false}>
              My BAR RO (NA/NR) is not equal to my OTA price
            </Radio>

            {matchOTAPrice === false && (
              <div className={styles.barForm}>
                <div className={styles.formula}>
                  <span>Booking.com Price* =</span>
                  <span>BAR</span>
                  <span>+</span>
                  <Form.Item
                    name={['customBar', 'value']}
                    rules={RULES}
                    noStyle
                  >
                    <CustomInput
                      onWheel={(e) => e.currentTarget.blur()}
                      min={0}
                      parser={parseInputNumber}
                    />
                  </Form.Item>
                  <Form.Item
                    name={['customBar', 'modifierType']}
                    rules={RULES}
                    noStyle
                  >
                    <Select>
                      <Select.Option value={ModifierType.RATE}>%</Select.Option>
                      <Select.Option value={ModifierType.FLAT}>
                        {currencySymbol}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </div>
                <span className={styles.info}>
                  *This is the non-genius price
                </span>
              </div>
            )}
          </div>
        </Radio.Group>
      </Form.Item>
    </ConfigStep>
  );
};
